import { UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ControlProperty, FileAttachment } from '../../../../../common/models';

export class AllocationViewActionAttachmentsModel {
  checkNeeded = false;
  comment: string;
  attachments: FileAttachment[];
}

export class AllocationViewActionAttachmentsForm {
  constructor(
    model: AllocationViewActionAttachmentsModel,
    fb: UntypedFormBuilder,
    public checkNeeded: ControlProperty<boolean> = model.checkNeeded,
    public comment: ControlProperty<string> = [model?.comment || '', []],
    public attachments: UntypedFormArray = fb.array([], []),
  ) {
    model?.attachments.forEach((file: FileAttachment) => {
      const attachmentData = fb.control(file.attachmentData);

      attachments.push(attachmentData);
    });
  }
}
